import CustomAmplitudeClient from "./custom-amplitude-client.2a7d9e3cb8c7.js";
import { CareQuality } from "./care-quality.20e94298087a.js";
import { PriceVerification } from "./price-verification.27ab346f994d.js";
import {
  OpenInsuranceSelectorEvent,
  bindHtmxInsuranceSwitching,
} from "./insurance-selector-events.87d20ca02104.js";

class CostBreakdownPage {
  constructor() {
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config);
    new PriceVerification();
    new CareQuality();

    this.bindContactProviderHandler();
    bindHtmxInsuranceSwitching();
    this.bindOpenInsuranceDialogHandler();
  }

  bindContactProviderHandler() {
    document.addEventListener("click", (e) => {
      const button = e.target.closest(".contact-provider");
      if (button) {
        this.amplitudeClient.trackStartContactProvider(button.dataset.location);
        const modal = document.querySelector("#contact-provider-modal");
        modal.showModal();
        modal.scrollIntoView();
      }
    });
  }

  bindOpenInsuranceDialogHandler() {
    document.addEventListener("click", (e) => {
      const button = e.target.closest("[data-action='open-insurance-dialog']");
      if (button) {
        document.dispatchEvent(
          new OpenInsuranceSelectorEvent(false, {
            navMethod: "cost-summary-button",
          }),
        );
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CostBreakdownPage();
});
